import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const SOCIAL_LINKS = [
  { label: 'YouTube', emoji: '\u25B6\uFE0F', href: '#youtube' },
  { label: 'TikTok', emoji: '\uD83C\uDFB5', href: '#tiktok' },
  { label: 'Instagram', emoji: '\uD83D\uDCF7', href: '#instagram' },
  { label: 'X / Twitter', emoji: '\uD83D\uDCAC', href: '#twitter' },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__grid">
          {/* Brand Column */}
          <div className="footer__brand">
            <Link to="/" className="footer__brand-logo">
              <span className="footer__brand-icon" role="img" aria-label="Graduation cap">
                \uD83C\uDF93
              </span>
              <span className="footer__brand-name">MiskTech University</span>
            </Link>
            <p className="footer__tagline">
              Where Future Builders Begin. Real tech skills for kids ages 8-18 &mdash;
              coding, AI, robotics, and more, taught through hands-on projects and guided
              by friendly AI mascots.
            </p>
            <div className="footer__socials">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="footer__social-link"
                  aria-label={social.label}
                  title={social.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span role="img" aria-hidden="true">{social.emoji}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Learn Column */}
          <div className="footer__column">
            <h3 className="footer__column-title">Learn</h3>
            <Link to="/courses" className="footer__link">All Courses</Link>
            <Link to="/ask-sage" className="footer__link">Ask Sage AI</Link>
            <Link to="/dashboard" className="footer__link">Student Dashboard</Link>
            <Link to="/parent" className="footer__link">Parent Portal</Link>
          </div>

          {/* Company Column */}
          <div className="footer__column">
            <h3 className="footer__column-title">Company</h3>
            <Link to="/about" className="footer__link">About Us</Link>
            <Link to="/pricing" className="footer__link">Pricing</Link>
            <Link to="/careers" className="footer__link">Careers</Link>
            <Link to="/blog" className="footer__link">Blog</Link>
          </div>

          {/* Contact Column */}
          <div className="footer__column">
            <h3 className="footer__column-title">Contact</h3>
            <a
              href="mailto:investor@miskulintechnologies.com"
              className="footer__email"
            >
              investor@miskulintechnologies.com
            </a>
            <Link to="/privacy" className="footer__link">Privacy Policy</Link>
            <Link to="/terms" className="footer__link">Terms of Service</Link>
            <Link to="/support" className="footer__link">Support</Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {currentYear} Miskulin Technologies. All rights reserved.
          </p>
          <div className="footer__bottom-links">
            <Link to="/privacy" className="footer__bottom-link">Privacy</Link>
            <Link to="/terms" className="footer__bottom-link">Terms</Link>
            <Link to="/cookies" className="footer__bottom-link">Cookies</Link>
            <Link to="/accessibility" className="footer__bottom-link">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
